import { useState } from 'react';
import { testimonials } from '@/mocks/home';

export default function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  const prev = () => {
    setActiveIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const next = () => {
    setActiveIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const active = testimonials[activeIndex];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-4">
            用户口碑
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            客户怎么说
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base leading-relaxed">
            来自真实用户的声音，是 aiye 不断前进的最大动力
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative bg-background-100 border border-background-200/70 rounded-2xl p-8 md:p-10">
            <div className="flex items-center gap-1 mb-5">
              {Array.from({ length: active.rating }).map((_, i) => (
                <i key={i} className="ri-star-fill text-accent-500 text-lg"></i>
              ))}
            </div>

            <blockquote className="text-base md:text-lg text-foreground-700 leading-relaxed mb-8 font-heading italic">
              &ldquo;{active.content}&rdquo;
            </blockquote>

            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={active.avatar}
                  alt={active.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="font-semibold text-foreground-950 text-sm">{active.name}</div>
                <div className="text-xs text-foreground-500">
                  {active.role}，{active.company}
                </div>
              </div>
            </div>

            <div className="absolute top-1/2 -translate-y-1/2 -left-4 md:-left-6">
              <button
                onClick={prev}
                className="w-10 h-10 rounded-full bg-background-50 border border-background-200 flex items-center justify-center hover:bg-background-200 transition-colors cursor-pointer"
                aria-label="上一条评价"
              >
                <i className="ri-arrow-left-s-line text-foreground-600"></i>
              </button>
            </div>
            <div className="absolute top-1/2 -translate-y-1/2 -right-4 md:-right-6">
              <button
                onClick={next}
                className="w-10 h-10 rounded-full bg-background-50 border border-background-200 flex items-center justify-center hover:bg-background-200 transition-colors cursor-pointer"
                aria-label="下一条评价"
              >
                <i className="ri-arrow-right-s-line text-foreground-600"></i>
              </button>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 mt-6">
            {testimonials.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setActiveIndex(idx)}
                className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  idx === activeIndex
                    ? 'bg-primary-500 w-6'
                    : 'bg-background-300 hover:bg-background-400'
                }`}
                aria-label={`切换到第 ${idx + 1} 条评价`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}